/**
 * Deployment lifecycle (ADR 0029): `planned` → `active` → `retired`. For ops-managed deployments
 * it is derived from the version chain; for import-derived ones the import sets it.
 */
export const DEPLOYMENT_STATUS_VALUES = ["planned", "active", "retired"] as const;
export type DeploymentStatusValue = (typeof DEPLOYMENT_STATUS_VALUES)[number];

const LABELS: Record<DeploymentStatusValue, string> = {
  planned: "Planned",
  active: "Active",
  retired: "Retired",
};

const BADGE_VARIANTS: Record<DeploymentStatusValue, "default" | "secondary" | "outline"> = {
  active: "default",
  planned: "secondary",
  retired: "outline",
};

function isKnownStatus(status: string | null | undefined): status is DeploymentStatusValue {
  return (DEPLOYMENT_STATUS_VALUES as readonly string[]).includes(status ?? "");
}

/** Sentence-case label; unknown values are shown verbatim rather than hidden. */
export function deploymentStatusLabel(status: string | null | undefined): string {
  if (isKnownStatus(status)) return LABELS[status];
  return status ?? "—";
}

export function deploymentStatusBadgeVariant(
  status: string | null | undefined,
): "default" | "secondary" | "outline" {
  return isKnownStatus(status) ? BADGE_VARIANTS[status] : "outline";
}
